var map = {
	"./angbao-bonus-cny.webp": 2507,
	"./angbao-bonus-dewali.webp": 2508,
	"./angbao-bonus-mooncake.webp": 2509,
	"./angbao-bonus-thaipusam.webp": 2510,
	"./angbao-bonus.webp": 2511,
	"./anni-lucky-draw.webp": 2512,
	"./cny-angbao-bonus.webp": 2513,
	"./cny-lucky-draw.webp": 2514,
	"./cny-promo.webp": 2515,
	"./dewali-promo.webp": 2516,
	"./dongzhi-angbao-bonus.webp": 2517,
	"./fifa-logo.webp": 2518,
	"./fifa-prediction.webp": 2519,
	"./fifa-qna.webp": 2520,
	"./uefa-predic.webp": 2521,
	"./welcome-cny-bonus.webp": 2522
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2506;